<script lang="ts">
	import Schedules from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Schedules.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
</script>

<Schedules {device} />
